import React from "react";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  StaticNonColorButton_Container: {
    margin: "auto",
    transition: "all 0.5s ease",
    transform: "none",
    borderRadius: "100px",
    cursor: "pointer",
    backgroundImage:
      "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%) !important",
    marginTop: "10px",
    padding: "2px",
    border: "none",
    "& span": {
      backgroundColor: "#0c091b",
      fontSize: "16px",
      color: "#fff",
      width: "198px",
      height: "60px",
      borderRadius: "100px",
      display: "inline-block",
      margin: "auto",
      alignItems: "end",
      textAlign: "center",
      padding: "18px 0",
      "&:hover": {
        backgroundImage:
          "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
        boxShadow: "0px 0px 31px 3px #3659f6",
      },
    },
    "&:hover": {
      backgroundImage: "none",
      backgroundColor: "transparent",
    },
  },
}));

export default function StaticOutlineButton(props) {
  const { buttonText, handleClick } = props;

  const classes = useStyles();

  return (
    <button
      className={classes.StaticNonColorButton_Container}
      onClick={() => handleClick()}
    >
      <span>{buttonText}</span>
    </button>
  );
}
